import * as React from "react";
const CallMobileIcon = (props) => (
  <svg
    width={100}
    height={100}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.9 55.9V75.8H28V25H57.9V44.9H60.9V22H25V78.8H60.9V55.9H57.9Z"
      fill="black"
    />
    <path
      d="M54.1004 63.3016L43.2004 52.4016H81.5004V48.4016H43.2004L54.1004 37.5016L51.7004 35.1016L36.4004 50.4016L51.7004 65.7016L54.1004 63.3016Z"
      fill="black"
    />
    <path
      d="M63.9 55.9V84.8C63.9 86.4 62.5 87.8 60.9 87.8H25C23.4 87.8 22 86.5 22 84.8V16C22 14.4 23.4 13 25 13H60.9C62.5 13 63.9 14.3 63.9 16V44.9H66.9V16C66.9 12.7 64.2 10 60.9 10H25C21.8 10 19 12.7 19 16V84.7C19 88 21.7 90.7 25 90.7H60.9C64.1 90.7 66.9 88 66.9 84.7V55.9H63.9Z"
      fill="black"
    />
  </svg>
);
export default CallMobileIcon;
